<template>
  <div id="free-value-selection-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">VALOR LIVRE</h2>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <div class="row">
          <p class="col-12" style="text-align: justify">
            {{ plano.valor_livre_txt }}
          </p>
        </div>

        <div class="row">
          <p class="col-12">
            <money
              @keyup.native="minimumPriceValidate(plano.valor)"
              :class="{ input: true, 'is-invalid': errors.has('valorlivre') }"
              name="valorlivre"
              v-validate="{ minimum_price: error }"
              type="text"
              class="form-control"
              v-model="user.valorlivre"
              id="valorlivre"
            >
            </money>

            <span class="invalid-feedback">
              {{ errors.first("valorlivre") }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
  },
  data() {
    return {
      error: false
    }
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)

    if (params.has('valorlivre')) this.user.valorlivre = params.get('valorlivre')

    this.minimumPriceValidate(this.plano.valor)
  },
  methods: {
    minimumPriceValidate(valorPlano){                        
      if(this.user.valorlivre >= valorPlano){
        this.error = false
      } else {
        this.error = true
      }
    },
    async submit() {
      try {
        if (!await this.$validator.validateAll()) throw new Error('Valor mínimo inválido')
        return true
      } catch (error) {
        $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing')
        return false
      }
    }
  }
})
</script>